var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-modal',[_c('Content',{attrs:{"title":_vm.title,"rows":_vm.rows}}),_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":_vm.open}},[_vm._v(" open nested modal ")]),_c('v-modal-close')],1)}
var staticRenderFns = []

export { render, staticRenderFns }